// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tablepopover{min-width:0!important;padding:0!important;border:0!important}", ""]);
// Exports
module.exports = exports;
